import { createAsyncThunk } from "@reduxjs/toolkit";
import { setErrorSnackBarMessage } from "../systemSlice";
import { errorToHandler } from "../../api/error";
import { RootState } from "app/store";
import { obsApi } from "api";
import { cleanDriveEndpointCommon } from "screens/DataMap/dataMap.utils";

export const fetchDriveMetrics = createAsyncThunk(
  "deployments/fetchDriveMetrics",
  async (
    drives: string | undefined,
    { rejectWithValue, getState, dispatch },
  ) => {
    const state = getState() as RootState;
    const simplifiedDrives = cleanDriveEndpointCommon(
      drives || "",
      state.dataMap.endpointsCommonParts,
    );
    return obsApi.drivesMetrics
      .getDrivesMetrics({
        startTime: state.deploymentMetrics.timeInterval,
        drives: simplifiedDrives,
      })
      .then((res) => {
        return res.data.results;
      })
      .catch((res) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
        return rejectWithValue(res);
      });
  },
);

export const fetchDriveOutliers = createAsyncThunk(
  "deployments/fetchDriveOutliers",
  async (_, { rejectWithValue, dispatch }) => {
    return obsApi.drivesMetrics
      .getOutlierDrives()
      .then((res) => {
        return res.data.results;
      })
      .catch((res) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
        return rejectWithValue(res);
      });
  },
);
